
// Полностью переписанный tooltip для блока доставки
document.addEventListener('DOMContentLoaded', function () {

  var triggers = document.querySelectorAll('.js-shipping-tooltip-trigger');
  var textTriggers = document.querySelectorAll('.js-shipping-tooltip-trigger-text');
  if (!triggers.length && !textTriggers.length) return;

  // Desktop: hover/focus on icon
  triggers.forEach(function (trigger) {
    var shippingBlock = trigger.closest('.product__product-shipping');
    var tooltip = shippingBlock.querySelector('.js-shipping-tooltip-text');
    if (!tooltip) return;
    trigger.addEventListener('mouseenter', function () {
      if (!isMobile()) tooltip.classList.add('active-tooltip');
    });
    trigger.addEventListener('mouseleave', function () {
      if (!isMobile()) tooltip.classList.remove('active-tooltip');
    });
    trigger.addEventListener('focus', function () {
      if (!isMobile()) tooltip.classList.add('active-tooltip');
    });
    trigger.addEventListener('blur', function () {
      if (!isMobile()) tooltip.classList.remove('active-tooltip');
    });
    // Mobile: click on icon
    trigger.addEventListener('click', function (e) {
      if (isMobile()) {
        e.stopPropagation();
        var isActive = shippingBlock.classList.contains('active-tooltip');
        document.querySelectorAll('.product__product-shipping.active-tooltip').forEach(function (el) {
          el.classList.remove('active-tooltip');
        });
        if (!isActive) {
          shippingBlock.classList.add('active-tooltip');
          tooltip.focus();
        }
      }
    });
  });

  // Mobile: click on text
  textTriggers.forEach(function (textTrigger) {
    var shippingBlock = textTrigger.closest('.product__product-shipping');
    var tooltip = shippingBlock.querySelector('.js-shipping-tooltip-text');
    if (!tooltip) return;
    textTrigger.addEventListener('click', function (e) {
      if (isMobile()) {
        e.stopPropagation();
        var isActive = shippingBlock.classList.contains('active-tooltip');
        document.querySelectorAll('.product__product-shipping.active-tooltip').forEach(function (el) {
          el.classList.remove('active-tooltip');
        });
        if (!isActive) {
          shippingBlock.classList.add('active-tooltip');
          tooltip.focus();
        }
      }
    });
    textTrigger.addEventListener('keydown', function (e) {
      if (isMobile() && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        textTrigger.click();
      }
    });
  });

  // Mobile: hide tooltip on outside click
  document.addEventListener('click', function (e) {
    if (isMobile()) {
      document.querySelectorAll('.product__product-shipping.active-tooltip').forEach(function (block) {
        if (!block.contains(e.target)) {
          block.classList.remove('active-tooltip');
        }
      });
    }
  });

  // Mobile: скрыть tooltip при клике вне
  document.addEventListener('click', function (e) {
    if (isMobile()) {
      document.querySelectorAll('.js-shipping-tooltip-text.active-tooltip').forEach(function (tooltip) {
        if (!tooltip.previousElementSibling || !tooltip.previousElementSibling.contains(e.target)) {
          tooltip.classList.remove('active-tooltip');
        }
      });
    }
  });

  // Вспомогательная функция для определения мобильного устройства
  function isMobile() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }
});
